<template>
  <div class="why-artos-accordion">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WhyArtosAccordion',
  
  mounted() {
    this.initAccordion()
  },
  
  methods: {
    initAccordion() {
      const items = this.$el.querySelectorAll('.why-artos__item')
      
      items.forEach((item, index) => {
        const header = item.querySelector('h3')
        const content = item.querySelector('.why-artos__item-content')
        
        // Set initial styles
        content.style.overflow = 'hidden'
        content.style.transition = 'height 0.3s ease'
        content.style.height = '0'
        
        // Open first item by default after DOM is ready
        if (index === 0) {
          header.classList.add('is-active')
          setTimeout(() => {
            content.style.height = `${content.scrollHeight}px`
          }, 30)
        }
        
        header.addEventListener('click', () => {
          const isActive = header.classList.contains('is-active')
          
          // Close all other items with animation
          items.forEach(otherItem => {
            const otherHeader = otherItem.querySelector('h3')
            const otherContent = otherItem.querySelector('.why-artos__item-content')
            
            if (otherItem !== item && otherHeader.classList.contains('is-active')) {
              otherHeader.classList.remove('is-active')
              otherContent.style.height = `${otherContent.scrollHeight}px`
              // Force reflow
              otherContent.offsetHeight
              otherContent.style.height = '0'
            }
          })
          
          // Toggle current item with animation
          if (!isActive) {
            header.classList.add('is-active')
            content.style.height = `${content.scrollHeight}px`
          } else {
            header.classList.remove('is-active')
            content.style.height = `${content.scrollHeight}px`
            // Force reflow
            content.offsetHeight
            content.style.height = '0'
          }
        })
      })
    }
  }
}
</script> 